import { render, staticRenderFns } from "./faturacomp.vue?vue&type=template&id=16fed5b2"
import script from "./faturacomp.vue?vue&type=script&lang=js"
export * from "./faturacomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports